module.exports = __webpack_public_path__ + "img/car_no_data.6d82bc52.png";